import { AUTH_CODE_PLACEHOLDER, AUTH_RECOVERY_CODE_LENGTH, OTP_RECOVERY_CODE_LABEL } from 'common/constants/auth';
import { AuthTextField } from 'pages/Auth/components/AuthTextField';
import { getFirstFieldMessage } from 'pages/Auth/components/OTP/OTP.utils';
import { AuthenticationRecoveryCodeInputProps } from './AuthenticationRecoveryCodeInput.props';

const AuthenticationRecoveryCodeInput = ({
  disabled = false,
  formState,
  handleBlur,
  handleChange,
  inputRef,
  onKeyDown,
}: AuthenticationRecoveryCodeInputProps) => {
  const { dbErrors, errors, touched, values } = formState;
  const helperText = touched.recoveryCode ? getFirstFieldMessage(errors?.recoveryCode) : undefined;
  const error = Boolean(helperText || getFirstFieldMessage(dbErrors?.recoveryCode));

  return (
    <AuthTextField
      autoComplete="one-time-code"
      disabled={disabled}
      id="enter-user-recovery-code"
      slotProps={{
        htmlInput: {
          inputMode: 'numeric',
          maxLength: AUTH_RECOVERY_CODE_LENGTH,
          onBlur: handleBlur,
          pattern: '[0-9]*',
        },
      }}
      name="recoveryCode"
      label={OTP_RECOVERY_CODE_LABEL}
      placeholder={AUTH_CODE_PLACEHOLDER}
      type="text"
      error={error}
      helperText={helperText}
      value={values.recoveryCode || ''}
      inputRef={inputRef}
      onChange={handleChange}
      onKeyDown={onKeyDown}
    />
  );
};

export default AuthenticationRecoveryCodeInput;
